
import React from "react";
import { Mail } from "lucide-react";

interface ContactInfoProps {
  email: string;
}

const ContactInfo = ({ email }: ContactInfoProps) => {
  return (
    <div className="mt-6 bg-elfGreen-light/30 p-4 rounded-lg flex items-center gap-3">
      <Mail size={24} className="text-elfGreen" />
      <span>Email: <a href={`mailto:${email}`} className="text-elfRed font-medium hover:underline">{email}</a></span>
    </div>
  );
};

export default ContactInfo;
